import { render, staticRenderFns } from "./DescriptionCard.vue?vue&type=template&id=887e819c"
import script from "./DescriptionCard.vue?vue&type=script&lang=ts"
export * from "./DescriptionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports